import { render, staticRenderFns } from "./HeadNav.vue?vue&type=template&id=5feaf60a&scoped=true"
import script from "./HeadNav.vue?vue&type=script&lang=js"
export * from "./HeadNav.vue?vue&type=script&lang=js"
import style0 from "./HeadNav.vue?vue&type=style&index=0&id=5feaf60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feaf60a",
  null
  
)

export default component.exports